import Vue from 'vue'
import VueRouter from 'vue-router'
import * as store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/download',
    name: 'Download',
    component: () => import(/* webpackChunkName: "share" */ '../views/Share.vue'),
    meta: {
      requiresAuth: false,
      hidesNavigation: true
    }
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import(/* webpackChunkName: "users" */ '../views/Users.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/areas',
    name: 'Areas',
    component: () => import(/* webpackChunkName: "areas" */ '../views/Areas.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/authorities',
    name: 'Authorities',
    component: () => import(/* webpackChunkName: "authorities" */ '../views/Authorities.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/employers',
    name: 'Employers',
    component: () => import(/* webpackChunkName: "employers" */ '../views/Employers.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
    meta: {
      requiresAuth: false,
      hidesNavigation: true
    }
  },
  {
    path: '/disallow-email-notifications/:token',
    name: 'DisallowEmailNotifications',
    component: () => import(/* webpackChunkName: "disallow-email-notifications" */ '../views/DisallowEmailNotifications.vue'),
    meta: {
      requiresAuth: false,
      hidesNavigation: true
    }
  },
  {
    path: '/reset-password/:token',
    name: 'ResetPassword',
    component: () => import(/* webpackChunkName: "reset-password" */ '../views/ResetPassword.vue'),
    meta: {
      requiresAuth: false,
      hidesNavigation: true
    }
  },
  {
    path: '/jobs',
    name: 'Jobs',
    component: () => import(/* webpackChunkName: "jobs" */ '../views/Jobs.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/branches',
    name: 'Branches',
    component: () => import(/* webpackChunkName: "branches" */ '../views/Branches.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/algorithms',
    name: 'Algorithms',
    component: () => import(/* webpackChunkName: "algorithms" */ '../views/Algorithms.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/job-listings',
    name: 'JobListings',
    component: () => import(/* webpackChunkName: "job-listings" */ '../views/JobListings.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/articles',
    name: 'Articles',
    component: () => import(/* webpackChunkName: "articles" */ '../views/Articles.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/push-templates',
    name: 'PushTemplates',
    component: () => import(/* webpackChunkName: "push-templates" */ '../views/PushTemplates.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/general-configurations',
    name: 'GeneralConfigurations',
    component: () => import(/* webpackChunkName: "general-configurations" */ '../views/Configurations/GeneralConfigurations.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/job-plans-configurations',
    name: 'JobPlansConfigurations',
    component: () => import(/* webpackChunkName: "job-plans-configurations" */ '../views/Configurations/JobPlansConfigurations.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/share/:type/:id',
    name: 'Share',
    component: () => import(/* webpackChunkName: "share" */ '../views/Share.vue'),
    meta: {
      requiresAuth: false,
      hidesNavigation: true
    }
  },
  {
    path: '/confirm/:token',
    name: 'EmailConfirmation',
    component: () => import(/* webpackChunkName: "email-confirmation" */ '../views/EmailConfirmation.vue'),
    meta: {
      requiresAuth: false,
      hidesNavigation: true
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const jwt = (store.default.getters.jwt)
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!jwt) {
      return next({ name: 'Login' })
    }
  }
  return next()
})

export default router
